import { render, staticRenderFns } from "./hotwordad.vue?vue&type=template&id=0dde699b&scoped=true"
import script from "./hotwordad.vue?vue&type=script&lang=js"
export * from "./hotwordad.vue?vue&type=script&lang=js"
import style0 from "./hotwordad.vue?vue&type=style&index=0&id=0dde699b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde699b",
  null
  
)

export default component.exports